import React from 'react';
import { Button, Tooltip } from '@mui/material';
import styles from './PlanHeroCard.module.css';
import { MANAGE_BLOCKED_TEXT } from './planHeroTexts';

/**
 * Aviso dentro do card principal (cancelamento agendado, pagamento pendente, suspensão).
 * tone: warning | error. A ação abre o portal de pagamento e fica bloqueada para quem não gerencia.
 */
const PlanHeroNotice = ({ tone = 'warning', title, children, actionLabel, onAction, canAct, blockedText = MANAGE_BLOCKED_TEXT }) => (
  <div className={`${styles.notice} ${tone === 'error' ? styles.noticeError : styles.noticeWarning}`}>
    <div className={styles.noticeText}>
      {title && <strong className={styles.noticeTitle}>{title}</strong>}
      <span>{children}</span>
      {!canAct && actionLabel && <span className={styles.noticeBlocked}>{blockedText}</span>}
    </div>
    {actionLabel && (
      <Tooltip title={canAct ? '' : blockedText} arrow>
        <span>
          <Button
            onClick={onAction}
            disabled={!canAct}
            className={styles.noticeButton}
            sx={{ textTransform: 'none', borderRadius: '10px', height: 36, px: 2, fontWeight: 600, whiteSpace: 'nowrap' }}
          >
            {actionLabel}
          </Button>
        </span>
      </Tooltip>
    )}
  </div>
);

export default PlanHeroNotice;
